export default "---\nname: The Blue Blood of Pangloss\ncount: 5\n# owner: HORSE                 # optional: callsign of the pilot holding it\n---\n"